import React from 'react';

import HtmlDocument from 'app/src/elements/HtmlDocument';
import html from './content';

const Terms = () => {
  return <HtmlDocument html={html} />;
};

export default Terms;
